import * as React from "react";
import { connect } from "react-redux";

import {
  Widget as WidgetComponent,
  WidgetProps,
} from "../../components/Widget/Widget";
import { StoreState } from "../../reducers";

class Widget extends React.Component<WidgetProps> {
  render() {
    return (
      <div
        className="Widget-container"
        style={{
          width: "100%",
          overflowY: "auto",
          userSelect: this.props.isEditing ? "none" : "inherit",
        }}
      >
        <WidgetComponent {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  editingConfigName: state.widget.editingConfigName,
});

export default connect(mapStateToProps, {})(Widget);
